import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import {isMobile} from "react-device-detect"
import {Helmet  } from 'react-helmet-async'
import {Links} from 'routes/PathLink'
//import {useAuth} from '../provider/AuthProvider'

import {
  useSuperInvestorQueryShdata,
} from '../../data/company';

import { Table } from "components/ui/table";
//import Pagination from '../components/ui/pagination';
import { Pagination, Select } from "antd";
import { t } from "i18next";
import { amount_format } from "components/config/Common";
import Breadcrumb  from "components/Breadcrumb";
import ShTable  from "components/ShTable";
import {APP_URL, APP_NAME} from 'components/config/Common'
import Seo from 'components/seo/seo'

const InvestorDetails = () => {	
	const navigate = useNavigate();
	
	const [product_slug, setProduct_slug] = useState('');	
	const [cat_arr, setCatArr] = useState([])	
	const [canonicalurl , setCanonicalurl] = useState('');	
	const [description, setDescription] = useState('');
	const {id} = useParams()
	//const { isUser, loginToken } = useAuth();
	//const { addCartItem, cartItem, updateItemQty, deleteCartItem, checkItemInCart, itemCartQty } = useCart();
	
	const [user_type, setUser_type] = useState('');
    const [snipetData, setSnipetData] = useState('');

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(process.env.REACT_APP_PAGE_LIMIT);
  const [orderBy, setOrder] = useState('created_at');
  const [sortedBy, setColumn] = useState('desc');
  	const [metaTitle, setMetaTitle] = useState()
  const [metaDesc, setMetaDesc] = useState()
  // SORTING
  const [sortInfo, setSortInfo] = useState({ key: null, order: null });
  const { search } = useLocation();
    const parameters = new URLSearchParams(search);
    let status_p = parameters.get('status');
    let show_p = parameters.get('show');
  
  /* useEffect(() => {
    let status_p = parameters.get('status');
    let show_p = parameters.get('show');
    console.log("status_p",status_p);
  
  }, [parameters]); */



  const onPagination = (current) => {
    //console.log("current Page",current);
    setPage(current);
  }

  const onPageSize = (value) => {
    setPageSize(value);
    setPage(1);
  }
    
  
	//console.log("slug",slug);
	const {
		superinvestorshdata,
    investorinfo,
    paginatorInfo,
		isLoading,
		error,
	} = useSuperInvestorQueryShdata({ 
    id
	});

  useEffect(() => {
    setMetaTitle(`${investorinfo?.investor_name} Portfolio – Holdings, Net Worth & Stock Picks`);
    setMetaDesc(`Track ${investorinfo?.investor_name}'s Indian stock portfolio, latest holdings, net worth, and investment strategy. See which stocks top investors are buying now.`);
},[investorinfo]);
  
console.log("superinvestorshdata",superinvestorshdata);

  /*useEffect(() => {
    setMetaTitle(investorDetails?.meta_title ? investorDetails?.meta_title : indicesDetails?.name);
    setMetaDesc(investorDetails?.meta_description ? investorDetails?.meta_description : indicesDetails?.name);
  
  }, [investorDetails]);
  */

  
	//console.log("product",product);
  
const totalPages = Math.ceil(paginatorInfo?.total / pageSize);

const breadcrumb = [
  {
    name:'Home',
    link:`${process.env.REACT_APP_URL}`,
  },
  {
    name:`Indian Top Investor`,
    link:`${process.env.REACT_APP_URL}${Links.SUPERINVESTORS}`
  },
  {
    name:`${investorinfo?.investor_name}`,
    link:null
  },
]

	return (
		<>
     <Helmet>
                </Helmet>
    <Seo 
        title={`${metaTitle} | ${APP_NAME}`}
        desc={metaDesc && metaDesc.substring(0, 200)}
        url={`${APP_URL}/investor/${id}`}
      />
		<Header  />        
        <div className="space-y-5 px-5">
          {investorinfo && <Breadcrumb breadcrumb={breadcrumb} />}
            <section className="bg-white shadow-sm z-50 rounded-xl p-5">
                <h2 className="text-2xl">{investorinfo?.investor_name}</h2>

             
               <ShTable 
                    data={superinvestorshdata} 
                    pageSize={pageSize} 
                    isLoading={isLoading} 
                    paginatorInfo={paginatorInfo}
                    totalPages={totalPages}
                    onPagination={onPagination}
                    onPageSize={onPageSize}
                />
                
            </section>
        </div>
		<Footer />
		</>
		);
};

export default InvestorDetails;